import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../app.store';
import type { LeavePolicyType, PolicyState } from './policies.type';

// Initialize state
const initialState: PolicyState = {
  leave_policy: {
    policy_types: [],
  },
};

// Policy slice
const policySlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    updateLeavePolicyTypeStatus: (
      state,
      { payload }: { payload: Omit<LeavePolicyType, 'name'> },
    ) => {
      const policyType = state.leave_policy.policy_types.find(
        (type) => type.key === payload.key,
      );
      if (policyType) {
        policyType.status = payload.status;
      }
    },
    setLeavePolicyType: (state, { payload }: { payload: LeavePolicyType }) => {
      const existingIndex = state.leave_policy.policy_types.findIndex(
        (type) => type.key === payload.key,
      );
      if (existingIndex >= 0) {
        state.leave_policy.policy_types[existingIndex] = {
          key: payload.key,
          status: payload.status || 'pending',
        };
      } else {
        state.leave_policy.policy_types.push({
          key: payload.key,
          status: payload.status || 'pending',
        });
      }
    },
    updateLeavePolicyType: (
      state,
      { payload }: { payload: LeavePolicyType },
    ) => {
      const policyType = state.leave_policy.policy_types.find(
        (type) => type.key === payload.key,
      );
      if (policyType) {
        if (payload.status !== undefined) {
          policyType.status = payload.status;
        }
      }
    },
    resetLeavePolicyType: (state) => {
      state.leave_policy.policy_types = [];
    },
    resetPolicyState: () => initialState,
  },
});

// Export actions
export const {
  updateLeavePolicyTypeStatus,
  setLeavePolicyType,
  updateLeavePolicyType,
  resetLeavePolicyType,
  resetPolicyState,
} = policySlice.actions;

// Export selectors
export const selectLeavePolicy = (state: RootState) =>
  state.policies.leave_policy;
export const selectLeavePolicyTypes = (state: RootState) =>
  state.policies.leave_policy.policy_types;

// Export reducer
export default policySlice.reducer;
